import * as z from "zod/v4";
import {
  type AccountId,
  accountIdFormat,
  freightPickupAccessorialPresetIdFormat,
} from "../ids";

const FreightPickupAccessorialPresetRowSchema_ = z.object({
  id: freightPickupAccessorialPresetIdFormat.schema,
  accountId: accountIdFormat.schema,
  name: z.string(),
  liftgateRequired: z.boolean(),
  insidePickup: z.boolean(),
  instructions: z.string().nullish(),
  isDefault: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const FreightPickupAccessorialPresetRowSchema: z.ZodType<FreightPickupAccessorialPresetRow> =
  FreightPickupAccessorialPresetRowSchema_;
export interface FreightPickupAccessorialPresetRow
  extends z.infer<typeof FreightPickupAccessorialPresetRowSchema_> {}

export interface CreateFreightPickupAccessorialPresetInput {
  accountId: AccountId;
  name: string;
  liftgateRequired: boolean;
  insidePickup: boolean;
  instructions?: string | null;
  isDefault?: boolean;
}
